import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent implements OnInit, OnChanges {
  @Input() isChecked: boolean = false;
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() inputId: string = '';
  @Input() binary: boolean = true;
  @Input() checkState: number = 0;
  @Input() fontSize: number = 14;
  @Input() grayCheckbox: boolean = false;
  @Input() darkGrayCheckbox: boolean = false;
  @Input() greenCheckbox: boolean = false;
  @Input() tooltip: string = '';
  @Input() tooltipIconPosition: string = '';
  @Input() tooltipStyleClass: string = '';

  @Input() labelInputStyleClass: string = 'checkbox-label';
  
  @Output() appChange = new EventEmitter<any>();

  @ViewChild('checkbox', { static: true }) checkbox: any;

  checkboxIcon: string = 'fal fa-check';

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: any) {
    if (!this.binary && changes.checkState) {
      const checkState = (changes && changes.checkState && changes.checkState.currentValue) || 0;

      if (checkState === 0) {
        this.isChecked = false;
      } else if (checkState === 1) {
        this.isChecked = true;
        this.checkboxIcon = 'fal fa-check';
      } else if (checkState === 2) {
        this.isChecked = true;
        this.checkboxIcon = 'fal fa-minus';
      }

      this.checkbox.value = this.isChecked;
    }
  }

  handleChange(event) {
    if (this.binary) {
      this.appChange.emit(event.checked);
    } else {
      this.appChange.emit(this.checkState);
    }
  }
}
